<ng-container *transloco="let t">
  <div class="form-container">
    <img src="assets/logo.png" alt="Logo" class="logo" />

    <div class="form-content" (keydown.enter)="verifyEmail()">
      <h1>{{ t("verificationEmailSent") }}</h1>
      <p>
        <span
          [innerHTML]="t('verificationEmailSentMessage', subtitleParams)"
        ></span>
        <span class="login-other-account" (click)="logout()">
          | {{ t("loginWithAnotherAccount") }}</span
        >
      </p>

      <p-inputotp
        #otpInput
        [(ngModel)]="otp"
        [length]="6"
        class="otp-input"
        [integerOnly]="true"
        required
      />

      <div class="buttons-row">
        <p-button
          (click)="requestNewVerificationEmail()"
          class="send-again-button"
          size="large"
          icon="pi pi-send"
          severity="secondary"
          [pTooltip]="t('sendAgain')"
          tooltipPosition="bottom"
          placeholder="Bottom"
        />

        <p-button
          [label]="t('confirm')"
          (click)="verifyEmail()"
          class="confirm-otp-button"
          size="large"
          icon="pi pi-check"
          [disabled]="otp.length !== 6"
        />
      </div>
    </div>
  </div>

  <div class="illustration-container">
    <img src="assets/login-image.jpeg" alt="Bike sharing" />
  </div>
</ng-container>
